import { jsx as b } from "react/jsx-runtime";
import c from "classnames";
import { forwardRef as f } from "react";
import e from "./index.es689.js";
const p = "blur", B = f(
  ({
    children: a,
    isActive: t = !0,
    variant: r = "text",
    style: o,
    screenReaderMsg: s = "This feature requires an upgrade to access",
    testId: l = p,
    "aria-label": u = "Blurred content",
    className: i,
    ...m
  }, d) => {
    const n = c(e.blur, i, {
      [e["blur--text"]]: r === "text",
      [e["blur--overlay"]]: r === "overlay"
    });
    return /* @__PURE__ */ b(
      "div",
      {
        className: t ? n : void 0,
        ref: d,
        style: o,
        "data-testid": l,
        "data-is-active": t,
        "data-variant": r,
        "aria-busy": "true",
        "aria-label": `${u}. ${s}`,
        role: "region",
        tabIndex: -1,
        ...m,
        children: a
      }
    );
  }
);
export {
  p as BLUR_DEFAULT_TESTID,
  B as Blur
};
//# sourceMappingURL=index.es163.js.map
